import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import { appContext } from "Router/routes";
import Spinner from "components/spinner";
import { formatDate } from "helper/dateFormat";
import moment from "moment";
import ShareDocumentsModal from "pages/NewFinance/Documents/ShareDocumentsModal/index";
import ViewDocumentModal from "pages/NewFinance/Documents/ViewDocumentModal/index";
import React, { useContext, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation, useParams } from "react-router-dom";
import NotAuthorized from "../../../components/NotAuthorized";
import { default as DetailsHeader } from "./AccountDetailsHeader";
import AccountNotFound from "./AccountNotFound/AccountNotFound";
import { default as AccountTabs } from "./AccountTabs";
import UserDetailsHeader from "./UserDetailsHeader";
import UserTabs from "./UserTabs";
import "./style.scss";
const MemberDetails = () => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const prevIdRef = React.useRef(null);
  const searchParams = new URLSearchParams(search);
  const tabParam = searchParams.get("tab");

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState(tabParam || "Account info");
  const [show, setShow] = useState();
  const [familyMember, setFamilyMember] = useState(false);
  const [account, setAccount] = useState({});
  const { getAccessTokenSilently } = useAuth0();
  const { id } = useParams();
  const [isMembersActive, setIsMembersActive] = React.useState(false);
  const [user, setUser] = useState(null);
  const [viewDocumentId, setViewDocumentId] = React.useState(null);
  const [openShareModal, setOpenShareModal] = React.useState(false);
  const [documentRow, setDocumentRow] = React.useState(null);
  const { typeUser, setTypeUser } = useContext(appContext);
  const [viewDocumentContent, setViewDocumentContent] = useState(null);
  const [notFoundError, setNotFoundError] = useState(false);

  const enableLoading = (value) => {
    setLoading(value);
  };
  useEffect(() => {
    if (history?.location?.state?.activeTab) {
      setUser(null);
      setSelected(history?.location?.state?.activeTab);
      return;
    } else if (
      (history?.location?.state == undefined ||
        history?.location?.state == null) &&
      selected === "Details"
    ) {
      setSelected("Family");
    }

    setUser(history?.location?.state ? history?.location?.state : null);
  }, [history?.location?.state]);

  React.useEffect(() => {
    // const id = history?.location?.pathname?.split("/")[2];
    const includeFamilyPath =
      history?.location?.pathname.includes("family-member");

    // Detect ID change
    if (prevIdRef.current !== null && prevIdRef.current !== id) {
      if (!includeFamilyPath) fetchMyAPI();
    }
    prevIdRef.current = id;

    if (!id) return;

    async function fetchMyAPI() {
      enableLoading(true);

      const token = await getAccessTokenSilently();
      // AuthService.getAccountById(!user ? id : user.account_id, token)
      AuthService.getAccountById(id, token)
        .then((res) => {
          if (res) {
            if (res[0] !== undefined) {
              setAccount(res[0]);
            } else {
              history.push(`/members`);
              toastr.error("Error", "Member Not found");
            }
          }
          enableLoading(false);
          setNotFoundError(false);
        })
        .catch((err) => {
          if (err?.status === 404 || err?.status === 400) {
            setNotFoundError(true);
          }
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
      // setSelected("Family");
    }

    if (!typeUser && !includeFamilyPath) fetchMyAPI();
  }, [refresh, id, selected]);

  useEffect(() => {
    setSelected(tabParam || "Account info");
  }, [tabParam]);

  useEffect(() => {
    return () => {
      setTypeUser(false);
    };
  }, []);

  const viewDocumentHandler = (documentId) => {
    setViewDocumentId(documentId);
  };
  const viewLetterHandler = (documentContent) => {
    setViewDocumentContent(documentContent);
  };

  const downloadFileHandler = async (row) => {
    const { _id, name, type } = row;
    const token = await getAccessTokenSilently();
    await FinanceService.downloadDocument(token, _id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const currentDate = formatDate({
        date: new Date(),
        formatType: "defaultWithUTC",
      });
      const fileType =
        type === "tax_statement"
          ? "Statement"
          : type.charAt(0).toUpperCase() + type.slice(1);
      const fileName = `${fileType}_${name.replaceAll(
        " ",
        "_"
      )}_${currentDate}`;
      link.setAttribute("download", `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const documentHandler = (row) => {
    setOpenShareModal(true);
    setDocumentRow(row);
  };

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "members" && item?.active == true) {
        return setIsMembersActive(item?.active);
      } else {
        return setIsMembersActive(false);
      }
    });

    setIsMembersActive(
      orgInfo?.find((item) => item?.moduleName === "members")?.active
    );
  }, []);

  return !isMembersActive ? (
    <NotAuthorized title={"Member Details"} />
  ) : notFoundError ? (
    <AccountNotFound />
  ) : (
    <div className="pt-5 details-member w-100">
      {!loading ? (
        <div className="">
          {!user ? (
            <DetailsHeader
              key={account?._id}
              account={account}
              setRefresh={setRefresh}
              refresh={refresh}
            />
          ) : (
            <UserDetailsHeader
              key={user?._id}
              user={user}
              account={user?.account}
              setSelected={setSelected}
              setRefresh={setRefresh}
              refresh={refresh}
            />
          )}
          {!user ? (
            <AccountTabs
              account={account}
              selected={selected}
              setSelected={setSelected}
              setShow={setShow}
              setRefresh={setRefresh}
              refresh={refresh}
              setFamilyMember={setFamilyMember}
              familyMember={familyMember}
              viewDocumentHandler={viewDocumentHandler}
              downloadFileHandler={downloadFileHandler}
              documentHandler={documentHandler}
              viewLetterHandler={viewLetterHandler}
            />
          ) : (
            <UserTabs
              user={user}
              account={account}
              selected={selected}
              setSelected={setSelected}
              setShow={setShow}
              setRefresh={setRefresh}
              refresh={refresh}
              setTypeUser={setTypeUser}
            />
          )}
          {/* <div className="border-line" /> */}
          {show}
        </div>
      ) : (
        <Spinner />
      )}
      <Dialog
        open={viewDocumentId !== null || viewDocumentContent !== null}
        onClose={() => {
          setViewDocumentId(null);
          setViewDocumentContent(null);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "90vh",
            overflow: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
    
        <ViewDocumentModal
          documentHtmlContent={viewDocumentContent ? viewDocumentContent : null}
          documentId={viewDocumentId ? viewDocumentId : null}
          closeModal={() => {
            setViewDocumentId(null);
            setViewDocumentContent(null);
          }}
        />
      </Dialog>
      <Dialog
        open={openShareModal}
        onClose={() => {
          setOpenShareModal(false);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "637px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ShareDocumentsModal
          closeModal={() => {
            setOpenShareModal(false);
          }}
          documentsIds={[documentRow?._id]}
          documentType={documentRow?.type}
          defaultEmail={account?.defaultEmails || []}
          type="Document"
        />
      </Dialog>
    </div>
  );
};
export default MemberDetails;
